/**
 * DiagRankIntegrity: Diagnostics drawer -- Market-Rank Integrity rows, moved verbatim out of src/pages/ScreenView.tsx (Screener Phase 3, 2026-10-28). Display only.
 */
import React from "react";
import { MICRO_LABEL } from "@components/cockpit";
import { badgeStyle, mutedText, secondaryText, ui } from "@components/screener/screenerUi";
import { type Tone } from "@lib/screenerTypes";

export type DiagRankIntegrityProps = {
  guardrailRows: { label: string; tone: Tone; status: string; detail: string; }[];
};

export default function DiagRankIntegrity({
  guardrailRows,
}: DiagRankIntegrityProps) {
  return (
    <div>
      <div className={`${MICRO_LABEL} mb-2`} style={mutedText}>Market-Rank Integrity</div>
      <div className="space-y-3">
        {guardrailRows.map((row) => (
          <div
            key={row.label}
            className="rounded-2xl border p-3"
            style={{ borderColor: ui.cardBorder }}
          >
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="font-semibold">{row.label}</div>
              <span style={badgeStyle(row.tone)}>{row.status}</span>
            </div>
            <div className="mt-2 text-sm" style={secondaryText}>
              {row.detail}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
